// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form___xlT4","signatureButtonsRight":"ModalSign_signatureButtonsRight__3llfK"};